import {SettingsParamType, createSettingsParams} from '@wix/tpa-settings'

export type ISettingsParams = {
  pageTitle: SettingsParamType.Text
  description: SettingsParamType.Text
  upcomingEventsTab: SettingsParamType.Text
  pastEventsTab: SettingsParamType.Text
  noUpcomingEvents: SettingsParamType.Text
  noUpcomingEventsLink: SettingsParamType.Text
  noUpcomingEventsLinkPageId: SettingsParamType.String
}

const settingsParams = createSettingsParams<ISettingsParams>({
  pageTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_pageTitle'),
  },
  description: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_description'),
  },
  upcomingEventsTab: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_upcomingEventsTab'),
  },
  pastEventsTab: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_pastEventsTab'),
  },
  noUpcomingEvents: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_noUpcomingEvents'),
  },
  noUpcomingEventsLink: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_noUpcomingEventsLink'),
  },
  noUpcomingEventsLinkPageId: {
    getDefaultValue: () => undefined,
  },
})

export default settingsParams
